export default {
  'The berth booking is not found': '予約が見つかりませんでした',
  '予約が見つかりませんでした': '予約が見つかりませんでした',
}
